import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { SeoNumberedSteps } from "@/components/seo/SeoNumberedSteps";
import { Clock, Palette, MapPin, Calendar, Star, Shield } from "lucide-react";

const WystepKomediowyCena = () => (
  <SeoPageLayout title="Występ komediowy" titleAccent="- cennik i wycena">
    <SeoSection title="Ile kosztuje występ komediowy?">
      <p>Cena występu komediowego zależy od wielu czynników - formatu, czasu trwania, lokalizacji i stopnia personalizacji materiału. Nie stosujemy sztywnego cennika, ponieważ każde wydarzenie jest inne. Zamiast tego przygotowujemy indywidualną wycenę dopasowaną do Twoich potrzeb i budżetu.</p>
    </SeoSection>

    <SeoSection title="Co wpływa na cenę występu?">
      <SeoFeatureGrid features={[
        { icon: Clock, title: "Czas trwania", description: "Od krótkiego 15-minutowego wejścia po godzinny show." },
        { icon: Palette, title: "Personalizacja", description: "Im więcej materiału 'szytego na miarę', tym więcej przygotowań." },
        { icon: MapPin, title: "Lokalizacja", description: "Dojazd do miejsca wydarzenia wpływa na wycenę." },
        { icon: Calendar, title: "Termin", description: "Weekendy i okres świąteczny mogą wiązać się z wyższą ceną." },
      ]} columns={2} />
    </SeoSection>

    <SeoSection title="Jak uzyskać wycenę?">
      <SeoNumberedSteps steps={[
        { title: "Opisz wydarzenie", description: "Wypełnij formularz kontaktowy lub zadzwoń. Opisz charakter wydarzenia, liczbę gości, datę i lokalizację." },
        { title: "Otrzymaj wycenę", description: "Przygotujemy bezpłatną, niezobowiązującą wycenę w ciągu 24 godzin." },
        { title: "Doradztwo formatu", description: "Chętnie doradzamy w kwestii formatu, by maksymalnie wykorzystać Twój budżet." },
      ]} />
    </SeoSection>

    <SeoSection title="Czy występ komediowy to dobra inwestycja?">
      <p>Zdecydowanie tak. Profesjonalny występ komediowy podnosi prestiż wydarzenia, buduje pozytywne wspomnienia i wzmacnia wizerunek firmy jako nowoczesnego pracodawcy. To nie wydatek - to inwestycja w morale zespołu, employer branding i kulturę organizacyjną, która procentuje przez miesiące po wydarzeniu.</p>
    </SeoSection>

    <SeoSection title="Gwarancja satysfakcji">
      <p>Stawiamy na najwyższą jakość. Każdy nasz występ jest poprzedzony starannym przygotowaniem i dopasowaniem do specyfiki wydarzenia. Setki zadowolonych klientów i 100% pozytywnych rekomendacji to najlepsza gwarancja, że Twoje wydarzenie będzie niezapomniane.</p>
      <SeoHighlightBox icon={Shield}>
        100% pozytywnych rekomendacji od klientów korporacyjnych. Setki udanych występów na eventach firmowych w całej Polsce.
      </SeoHighlightBox>
    </SeoSection>
  </SeoPageLayout>
);

export default WystepKomediowyCena;
